const heroContent = [
  {
    id: "1",
    image: "https://www.zindagitrust.org/img/sections/3.jpg",
    heroTitle: "REFORMING THE EDUCATION SYSTEM",
    heroSubTitle: "Through Pilot Projects and Advocacy",
  },
  {
    id: "2",
    image: "https://www.zindagitrust.org/img/sections/1n.jpg",
    heroTitle: "A YEAR IN REVIEW",
    heroSubTitle:
      "Enjoy a snapshot of our activities and achievements at our schools",
  },
  {
    id: "3",
    image: "https://www.zindagitrust.org/img/sections/review.jpg",
    heroTitle: "TRANSFORMING STUDENT LIVES",
    heroSubTitle: "by delivering Holistic Education at Government Schools",
  },
  {
    id: "4",
    image: "https://pbs.twimg.com/media/E_ZLRbzUUAA6LR_.jpg:large",
    heroTitle: "assignment orientation class schedule",
    heroSubTitle:
      "Enjoy a snapshot of our activities and achievements at our schools",
  },
  {
    id: "5",
    image: "https://live.staticflickr.com/1385/1117178912_2b41e8bbf8_b.jpg",
    heroTitle: "TRANSFORMING STUDENT LIVES",
    heroSubTitle: "Through Pilot Projects and Advocacy",
  },
];

export default heroContent;
